import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
const useSandboxOutcomeOptions = () => {
  const $ = _c(58);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "sandboxOutcome"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = {
      label: t1,
      value: "pass"
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const pass = t2;
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp2);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = {
      label: t3,
      value: "fail"
    };
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const fail = t4;
  let t5;
  if ($[9] !== t) {
    t5 = t(_temp3);
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = {
      label: t5,
      value: "manual_review"
    };
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const manualReview = t6;
  let t7;
  if ($[13] !== t) {
    t7 = t(_temp4);
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = {
      label: t7,
      value: "step_up"
    };
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const stepUp = t8;
  let t9;
  if ($[17] !== t) {
    t9 = t(_temp5);
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = {
      label: t9,
      value: "use_rules_outcome"
    };
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const evaluateRules = t10;
  let t11;
  if ($[21] !== t) {
    t11 = t(_temp6);
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11) {
    t12 = {
      label: t11,
      value: "choose_branch_outcomes"
    };
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  const chooseBranch = t12;
  let t13;
  if ($[25] !== t) {
    t13 = t(_temp7);
    $[25] = t;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13) {
    t14 = {
      label: t13,
      value: "pass"
    };
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  const idDocPass = t14;
  let t15;
  if ($[29] !== t) {
    t15 = t(_temp8);
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t15) {
    t16 = {
      label: t15,
      value: "fail"
    };
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  const idDocFail = t16;
  let t17;
  if ($[33] !== t) {
    t17 = t(_temp9);
    $[33] = t;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t17) {
    t18 = {
      label: t17,
      value: "real"
    };
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  const idDocReal = t18;
  let t19;
  if ($[37] !== t) {
    t19 = t(_temp10);
    $[37] = t;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t19) {
    t20 = {
      label: t19,
      value: "simulated"
    };
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  const idDocSimulated = t20;
  let t21;
  if ($[41] !== chooseBranch || $[42] !== evaluateRules || $[43] !== fail || $[44] !== manualReview || $[45] !== pass || $[46] !== stepUp) {
    t21 = [pass, fail, manualReview, stepUp, evaluateRules, chooseBranch];
    $[41] = chooseBranch;
    $[42] = evaluateRules;
    $[43] = fail;
    $[44] = manualReview;
    $[45] = pass;
    $[46] = stepUp;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== idDocFail || $[49] !== idDocPass) {
    t22 = [idDocPass, idDocFail];
    $[48] = idDocFail;
    $[49] = idDocPass;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== idDocReal || $[52] !== idDocSimulated) {
    t23 = [idDocReal, idDocSimulated];
    $[51] = idDocReal;
    $[52] = idDocSimulated;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== t21 || $[55] !== t22 || $[56] !== t23) {
    t24 = {
      overallOutcomeOptions: t21,
      idDocSimulatedOptions: t22,
      idDocVerificationOptions: t23
    };
    $[54] = t21;
    $[55] = t22;
    $[56] = t23;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  return t24;
};
export default useSandboxOutcomeOptions;
function _temp($) {
  return $["overall-outcome"].outcome.options.success.title;
}
function _temp2($_0) {
  return $_0["overall-outcome"].outcome.options.fail.title;
}
function _temp3($_1) {
  return $_1["overall-outcome"].outcome.options["manual-review"].title;
}
function _temp4($_2) {
  return $_2["overall-outcome"].outcome.options["step-up"].title;
}
function _temp5($_3) {
  return $_3["overall-outcome"].outcome.options["evaluate-rules"].title;
}
function _temp6($_4) {
  return $_4["overall-outcome"].outcome.options["choose-branch"].title;
}
function _temp7($_5) {
  return $_5["id-doc-outcome"]["simulated-outcome"].options.success.title;
}
function _temp8($_6) {
  return $_6["id-doc-outcome"]["simulated-outcome"].options.fail.title;
}
function _temp9($_7) {
  return $_7["id-doc-outcome"]["real-outcome"].title;
}
function _temp10($_8) {
  return $_8["id-doc-outcome"]["simulated-outcome"].title;
}